import { makeAutoObservable, observable } from 'mobx'
import { AccessPropertyType, DescriptionType } from './poperty'

type TeacherDescType = {
	id_okno_description_teacher: number
	id_teacher: number
	id_user: number
	okno_description: string
}

export interface TeacherPropertyType {
	id_okno_properties: number
	okno_title: string
	okno_pole: string
	id_okno_sotrudnik: number
	id_teacher: number
	dolg: number
	pole: number
	visibility: boolean
}

class TeacherProperty {
	desription: TeacherDescType[] = []
	dolgProperty: TeacherPropertyType[] = []
	accessProperty: AccessPropertyType[] = [
		{ pole: 'ckb', visibles: true },
		{ pole: 'dekanat', visibles: true },
		{ pole: 'KjMTB', visibles: true },
		{ pole: 'obshejitie', visibles: true },
		{ pole: 'biblioteka', visibles: false },
		{ pole: 'Buhgalteriy', visibles: false },
		{ pole: 'pole1', visibles: true },
		{ pole: 'pole2', visibles: false },
		{ pole: 'pole3', visibles: false }
	]
	tempVar: AccessPropertyType[] = []
	photo: string = ''

	constructor() {
		makeAutoObservable(this, {
			desription: observable
		})
	}

	newDescription(param: TeacherDescType[]) {
		this.desription = param
	}

	newDolgProperty(param: TeacherPropertyType[]) {
		this.dolgProperty = param
	}

	newAccessProperty(param: AccessPropertyType[]) {
		this.accessProperty = param
	}

	newPhoto(param: string) {
		this.photo = param
	}

	newTempVar(param: any) {
		this.tempVar = param
	}
}

export const teacherProperty = new TeacherProperty()
